let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8I61X")).then(() => parcelRequire('b2cpi'));